import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  ProviderScheduleEntry,
  ReportResult,
  ScheduleResponse,
  CreateScheduleRequest,
  UpdateScheduleRequest,
} from '@models/report-template.model';

export const ReportingActions = createActionGroup({
  source: 'Reporting',
  events: {
    // Run Report (on-demand)
    'Run Report': props<{ params: { providerId: string; emails: string[] } }>(),
    'Run Report Success': props<{ fileBlob: Blob; fileName: string }>(),
    'Run Report Failure': props<{ error: string }>(),

    // Bulk Run Report (async, multi-provider)
    'Bulk Run Report': props<{ providers: ProviderScheduleEntry[]; emailRecipients: string[] | null }>(),
    'Bulk Run Report Success': props<{ queuedProviderIds: string[] }>(),
    'Bulk Run Report Failure': props<{ error: string }>(),
    'Bulk Run Report Partial Failure': props<{ error: string; queuedProviderIds: string[]; failedProviderIds: string[] }>(),

    // View template
    'View Report Template': emptyProps(),
    'View Report Template Success': props<{ fileBlob: Blob }>(),
    'View Report Template Failure': props<{ error: string }>(),

    // Org audit export
    'Export Org Audit': emptyProps(),
    'Export Org Audit Success': props<{ fileBlob: Blob; fileName: string }>(),
    'Export Org Audit Failure': props<{ error: string }>(),

    // Organizational Reports (generated results)
    'Load Report Results': emptyProps(),
    'Load Report Results Success': props<{ results: ReportResult[]; totalCount: number }>(),
    'Load Report Results Failure': props<{ error: string }>(),

    'View Report Result': props<{ id: number }>(),
    'View Report Result Success': props<{ fileBlob: Blob }>(),
    'View Report Result Failure': props<{ error: string }>(),

    'Download Report Result': props<{ id: number }>(),
    'Download Report Result Success': props<{ fileBlob: Blob; fileName: string }>(),
    'Download Report Result Failure': props<{ error: string }>(),

    'Delete Report Result': props<{ id: number }>(),
    'Delete Report Result Success': props<{ id: number }>(),
    'Delete Report Result Failure': props<{ error: string }>(),

    // Scheduled Reports
    'Load Schedules': emptyProps(),
    'Load Schedules Success': props<{ schedules: ScheduleResponse[]; totalCount: number }>(),
    'Load Schedules Failure': props<{ error: string }>(),

    'Create Schedule': props<{ request: CreateScheduleRequest }>(),
    'Create Schedule Success': props<{ schedules: ScheduleResponse[] }>(),
    'Create Schedule Failure': props<{ error: string; isDuplicate: boolean }>(),

    'Update Schedule': props<{ id: number; request: UpdateScheduleRequest }>(),
    'Update Schedule Success': props<{ schedule: ScheduleResponse }>(),
    'Update Schedule Failure': props<{ error: string }>(),

    'Delete Schedule': props<{ id: number }>(),
    'Delete Schedule Success': props<{ id: number }>(),
    'Delete Schedule Failure': props<{ error: string }>(),

    'Reactivate Schedule': props<{ id: number }>(),
    'Reactivate Schedule Success': props<{ schedule: ScheduleResponse }>(),
    'Reactivate Schedule Failure': props<{ error: string; isDuplicate: boolean }>(),

    'Set Show Inactive Schedules': props<{ showInactive: boolean }>(),

    'Reset Running State': emptyProps(),
  },
});
